import React from 'react';

const MainIcons = {
  SampleIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8053 19.9038L16.625 18.1394C16.9935 18.0225 17.3089 17.833 17.5709 17.5709C17.833 17.3089 18.0225 16.9935 18.1394 16.625L19.9062 10.8028C19.9671 10.5914 19.9163 10.4051 19.7537 10.2441C19.5912 10.083 19.4049 10.0338 19.1947 10.0963L13.375 11.8606C13.0065 11.9775 12.6911 12.167 12.4291 12.4291C12.167 12.6911 11.9775 13.0065 11.8606 13.375L10.0938 19.1972C10.0329 19.4086 10.0838 19.5949 10.2463 19.7559C10.4088 19.917 10.5951 19.9663 10.8053 19.9038ZM14.9972 16.6347C14.5424 16.6347 14.1568 16.4754 13.8403 16.1569C13.5236 15.8385 13.3653 15.452 13.3653 14.9972C13.3653 14.5424 13.5246 14.1568 13.8431 13.8403C14.1615 13.5236 14.548 13.3653 15.0028 13.3653C15.4576 13.3653 15.8432 13.5246 16.1597 13.8431C16.4764 14.1615 16.6347 14.548 16.6347 15.0028C16.6347 15.4576 16.4754 15.8432 16.1569 16.1597C15.8385 16.4764 15.452 16.6347 14.9972 16.6347ZM15.0022 26.875C13.3597 26.875 11.8158 26.5633 10.3706 25.94C8.92542 25.3167 7.66833 24.4707 6.59937 23.4022C5.53042 22.3336 4.68406 21.0771 4.06031 19.6325C3.43677 18.1879 3.125 16.6445 3.125 15.0022C3.125 13.3597 3.43667 11.8158 4.06 10.3706C4.68333 8.92542 5.52927 7.66833 6.59781 6.59937C7.66635 5.53042 8.92292 4.68406 10.3675 4.06031C11.8121 3.43677 13.3555 3.125 14.9978 3.125C16.6403 3.125 18.1842 3.43667 19.6294 4.06C21.0746 4.68333 22.3317 5.52927 23.4006 6.59781C24.4696 7.66635 25.3159 8.92292 25.9397 10.3675C26.5632 11.8121 26.875 13.3555 26.875 14.9978C26.875 16.6403 26.5633 18.1842 25.94 19.6294C25.3167 21.0746 24.4707 22.3317 23.4022 23.4006C22.3336 24.4696 21.0771 25.3159 19.6325 25.9397C18.1879 26.5632 16.6445 26.875 15.0022 26.875ZM15 25C17.7787 25 20.1401 24.028 22.0841 22.0841C24.028 20.1401 25 17.7787 25 15C25 12.2213 24.028 9.8599 22.0841 7.91594C20.1401 5.97198 17.7787 5 15 5C12.2213 5 9.8599 5.97198 7.91594 7.91594C5.97198 9.8599 5 12.2213 5 15C5 17.7787 5.97198 20.1401 7.91594 22.0841C9.8599 24.028 12.2213 25 15 25Z"
        fill={fill}
      />
    </svg>
  ),
  CheckedIcon: ({
    width = '24px',
    height = '24px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
    strokeWidth = '1.7',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m5 12 5 5L20 6"></path>
    </svg>
  ),
  closeIcon: ({
    width = '24px',
    height = '24px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.50588C0 3.3605 3.3605 0 7.50588 0C11.6513 0 15.0117 3.3605 15.0117 7.50588C15.0117 11.6512 11.6513 15.0117 7.50588 15.0117C3.3605 15.0117 0 11.6512 0 7.50588ZM7.50588 1.07666C3.95512 1.07666 1.07667 3.95512 1.07667 7.50588C1.07667 11.0566 3.95512 13.9351 7.50588 13.9351C11.0566 13.9351 13.935 11.0566 13.935 7.50588C13.935 3.95512 11.0566 1.07666 7.50588 1.07666ZM10.1734 4.83865C10.3946 5.05994 10.3946 5.41874 10.1734 5.64004L8.3074 7.506L10.1734 9.37198C10.3946 9.59328 10.3946 9.95208 10.1734 10.1734C9.95208 10.3947 9.59328 10.3947 9.37198 10.1734L7.506 8.30739L5.64004 10.1734C5.41874 10.3947 5.05994 10.3947 4.83865 10.1734C4.61735 9.95208 4.61735 9.59328 4.83865 9.37198L6.70462 7.506L4.83865 5.64004C4.61735 5.41874 4.61735 5.05994 4.83865 4.83865C5.05994 4.61735 5.41874 4.61735 5.64004 4.83865L7.506 6.70462L9.37198 4.83865C9.59328 4.61735 9.95208 4.61735 10.1734 4.83865Z"
        fill="#676879"
      />
    </svg>
  ),
  plusIcon: ({
    width = '24px',
    height = '24px',
    fill = 'var(--icon-color)',
    onClick = null,
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 12.75H6.25C6.0375 12.75 5.85942 12.6781 5.71575 12.5342C5.57192 12.3904 5.5 12.2122 5.5 11.9997C5.5 11.7871 5.57192 11.609 5.71575 11.4655C5.85942 11.3218 6.0375 11.25 6.25 11.25H11.25V6.25C11.25 6.0375 11.3219 5.85942 11.4658 5.71575C11.6096 5.57192 11.7878 5.5 12.0003 5.5C12.2129 5.5 12.391 5.57192 12.5345 5.71575C12.6782 5.85942 12.75 6.0375 12.75 6.25V11.25H17.75C17.9625 11.25 18.1406 11.3219 18.2843 11.4658C18.4281 11.6096 18.5 11.7878 18.5 12.0003C18.5 12.2129 18.4281 12.391 18.2843 12.5345C18.1406 12.6782 17.9625 12.75 17.75 12.75H12.75V17.75C12.75 17.9625 12.6781 18.1406 12.5342 18.2843C12.3904 18.4281 12.2122 18.5 11.9997 18.5C11.7871 18.5 11.609 18.4281 11.4655 18.2843C11.3218 18.1406 11.25 17.9625 11.25 17.75V12.75Z"
        fill={fill}
      />
    </svg>
  ),
  minusIcon: ({
    width = '24px',
    height = '24px',
    fill = 'var(--icon-color)',
    onClick = null,
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 12h14"></path>
    </svg>
  ),
  facebookIcon: ({
    width = '24px',
    height = '24px',
    fill = 'var(--icon-color)',
    onClick = null,
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z"
        fill="white"
      />
      <path
        d="M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z"
        stroke={fill}
      />
      <g clipPath="url(#clip0_283_7171)">
        <path
          d="M30 20C30 14.4771 25.5229 10 20 10C14.4771 10 10 14.4771 10 20C10 24.9912 13.6568 29.1283 18.4375 29.8785V22.8906H15.8984V20H18.4375V17.7969C18.4375 15.2906 19.9305 13.9062 22.2146 13.9062C23.3084 13.9062 24.4531 14.1016 24.4531 14.1016V16.5625H23.1922C21.95 16.5625 21.5625 17.3334 21.5625 18.125V20H24.3359L23.8926 22.8906H21.5625V29.8785C26.3432 29.1283 30 24.9912 30 20Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_283_7171">
          <rect width="20" height="20" fill="white" transform="translate(10 10)" />
        </clipPath>
      </defs>
    </svg>
  ),
  twitterIcon: ({
    width = '24px',
    height = '24px',
    fill = 'var(--icon-color)',
    onClick = null,
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z"
        fill="none"
      />
      <path
        d="M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z"
        stroke={fill}
      />
      <path
        d="M16.2918 28.1251C23.8371 28.1251 27.9652 21.8724 27.9652 16.4517C27.9652 16.2759 27.9613 16.0962 27.9535 15.9204C28.7566 15.3397 29.4496 14.6203 30 13.7962C29.2521 14.129 28.458 14.3463 27.6449 14.4407C28.5011 13.9275 29.1421 13.1213 29.4492 12.1716C28.6438 12.6489 27.763 12.9856 26.8445 13.1673C26.2257 12.5098 25.4075 12.0744 24.5164 11.9285C23.6253 11.7826 22.711 11.9343 21.9148 12.3602C21.1186 12.7861 20.4848 13.4624 20.1115 14.2845C19.7382 15.1067 19.6462 16.029 19.8496 16.9087C18.2187 16.8269 16.6233 16.4032 15.1667 15.6652C13.71 14.9272 12.4247 13.8913 11.3941 12.6247C10.8703 13.5278 10.71 14.5965 10.9459 15.6135C11.1817 16.6306 11.7959 17.5197 12.6637 18.1001C12.0122 18.0794 11.375 17.904 10.8047 17.5884V17.6392C10.8041 18.5869 11.1317 19.5056 11.7319 20.2391C12.3321 20.9726 13.1678 21.4756 14.0969 21.6626C13.4934 21.8277 12.86 21.8518 12.2457 21.7329C12.5079 22.548 13.018 23.2609 13.7048 23.7721C14.3916 24.2833 15.2209 24.5673 16.077 24.5845C14.6237 25.726 12.8285 26.3452 10.9805 26.3423C10.6527 26.3418 10.3253 26.3217 10 26.2821C11.8774 27.4866 14.0613 28.1263 16.2918 28.1251Z"
        fill={fill}
      />
    </svg>
  ),
  linkedinIcon: ({
    width = '24px',
    height = '24px',
    fill = 'var(--icon-color)',
    onClick = null,
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z"
        fill="white"
      />
      <path
        d="M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z"
        stroke={fill}
      />
      <g clipPath="url(#clip0_283_7177)">
        <path
          d="M28.5195 10H11.4766C10.6602 10 10 10.6445 10 11.4414V28.5547C10 29.3516 10.6602 30 11.4766 30H28.5195C29.3359 30 30 29.3516 30 28.5586V11.4414C30 10.6445 29.3359 10 28.5195 10ZM15.9336 27.043H12.9648V17.4961H15.9336V27.043ZM14.4492 16.1953C13.4961 16.1953 12.7266 15.4258 12.7266 14.4766C12.7266 13.5273 13.4961 12.7578 14.4492 12.7578C15.3984 12.7578 16.168 13.5273 16.168 14.4766C16.168 15.4219 15.3984 16.1953 14.4492 16.1953ZM27.043 27.043H24.0781V22.4023C24.0781 21.2969 24.0586 19.8711 22.5352 19.8711C20.9922 19.8711 20.7578 21.0781 20.7578 22.3242V27.043H17.7969V17.4961H20.6406V18.8008H20.6797C21.0742 18.0508 22.043 17.2578 23.4844 17.2578C26.4883 17.2578 27.043 19.2344 27.043 21.8047V27.043Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_283_7177">
          <rect width="20" height="20" fill="white" transform="translate(10 10)" />
        </clipPath>
      </defs>
    </svg>
  ),
  ChatIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 5h14v10H9l-4 4z"
        fill="none"
        stroke={fill}
        strokeWidth={1.7}
        strokeLinejoin="round"
      />
      <path d="M8.5 10h7" fill="none" stroke={fill} strokeWidth={1.7} strokeLinecap="round" />
    </svg>
  ),
  flashIcon: ({
    width = '17px',
    height = '17px',
    fill = 'var(--icon-color)',
    onClick = null,
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 2 4 14h6l-1 8 9-12h-6z"
        fill="none"
        stroke={fill}
        strokeWidth={1.7}
        strokeLinejoin="round"
      />
    </svg>
  ),

  sendIcon: ({
    width = '24px',
    height = '24px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9282 2.4073C12.796 2.2772 12.64 2.17522 12.4694 2.1072C12.1308 1.96427 11.7511 1.96427 11.4126 2.1072C11.2419 2.17522 11.086 2.2772 10.9537 2.4073L4.40907 9.13377C4.14723 9.40288 4.00014 9.76786 4.00014 10.1484C4.00014 10.529 4.14723 10.894 4.40907 11.1631C4.6709 11.4322 5.02603 11.5833 5.39632 11.5833C5.76661 11.5833 6.12174 11.4322 6.38357 11.1631L10.5505 6.86604V20.5709C10.5505 20.9499 10.697 21.3134 10.9577 21.5814C11.2185 21.8494 11.5722 22 11.941 22C12.3097 22 12.6634 21.8494 12.9242 21.5814C13.185 21.3134 13.3315 20.9499 13.3315 20.5709V9.43123V6.86604L15.1252 8.72384C15.2545 8.85779 17.8972 11.5222 18.0667 11.5947C18.2361 11.6673 18.4179 11.7046 18.6014 11.7046C18.785 11.7046 18.9667 11.6673 19.1362 11.5947C19.3056 11.5222 19.4594 11.4158 19.5887 11.2819C19.719 11.149 19.8225 10.991 19.8931 10.8168C19.9637 10.6427 20 10.4559 20 10.2673C20 10.0786 19.9637 9.89181 19.8931 9.71766C19.8225 9.54351 19.719 9.38546 19.5887 9.2526L12.9282 2.4073Z"
        fill={fill}
      />
    </svg>
  ),
  deleteIcon: ({
    width = '19px',
    height = '19px',
    fill = '#999',
    onClick = null,
    className = '',
  }) => (
    <svg
      width={width}
      height={height}
      className={`${className}`}
      onClick={onClick}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7 4C10.2085 4 9.76681 4.24478 9.46104 4.62699C9.15759 5.00631 9 5.50123 9 6V7H7.5H5.5C5.22386 7 5 7.22386 5 7.5C5 7.77614 5.22386 8 5.5 8H7V18.3C7 18.739 7.16111 19.167 7.45856 19.4882C7.7572 19.8108 8.17086 20 8.61111 20H16.3889C16.8291 20 17.2428 19.8108 17.5414 19.4882C17.8389 19.167 18 18.739 18 18.3V8H19.5C19.7761 8 20 7.77614 20 7.5C20 7.22386 19.7761 7 19.5 7H17.5H16V6C16 5.50123 15.8424 5.00631 15.539 4.62699C15.2332 4.24478 14.7915 4 14.3 4H10.7ZM15 7V6C15 5.70312 14.9047 5.43498 14.7581 5.25169C14.6138 5.07129 14.4451 5 14.3 5H10.7C10.5549 5 10.3862 5.07129 10.2419 5.25169C10.0953 5.43498 10 5.70312 10 6V7H15ZM9.5 8H8V18.3C8 18.4975 8.07302 18.68 8.19232 18.8088C8.31042 18.9364 8.46199 19 8.61111 19H16.3889C16.538 19 16.6896 18.9364 16.8077 18.8088C16.927 18.68 17 18.4975 17 18.3V8H15.5H9.5Z"
        fill={fill}
      /> */}
      <path
        d="M5 7h14M10 7V5h4v2M6.5 7l.8 12.5h9.4L17.5 7"
        fill="none"
        stroke={fill}
        strokeWidth={1.7}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11v5M14 11v5"
        fill="none"
        stroke={fill}
        strokeWidth={1.7}
        strokeLinecap="round"
      />
    </svg>
  ),
  editIcon: ({
    width = '12px',
    height = '10px',
    fill = '#999',
    onClick = null,
    className = '',
  }) => (
    // <svg
    //   viewBox="0 0 24 24"
    //   width={width}
    //   height={height}
    //   className={`${className}`}
    //   onClick={onClick}
    //   fill="none"
    //   stroke={fill}
    //   strokeWidth="1.7"
    //   strokeLinecap="round"
    //   strokeLinejoin="round"
    // >
    //   <path d="M12 20h8M4 20l1-4L16 5l3 3L8 19z"></path>
    // </svg>
    <svg
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={`${className}`}
      onClick={onClick}
      fill="none"
    >
      <path
        d="M14.5 5.5l4 4L9 19H5v-4z"
        fill="none"
        stroke={fill}
        strokeWidth={1.7}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  // ==============

  logoIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 448.45 454.9"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M178.9,32.9c-4.5-3.9-9.2-8-13.8-11.9-12.7-11-30.6-13.4-45.8-4.5-4.3,2.5-8.5,6.4-11.9,9.4C95.9,36.3,85.2,46.2,74.2,57.3c-20.7,20.9-42,45-57.9,71.4-4,6.7-12.4,21-14.4,28.9l22.4-.1c3.1-7.6,8.3-15.8,12.3-22.3,6.8-11,29.2-39.2,38.5-49.1,16.6-17.5,29.5-30.6,48.7-47.2s33.2,2.3,39.9,7.9a557.9,557.9,0,0,0-45.8,50.8c-12,14.8-28.2,38.2-36.2,59.7l22.2.2c6.9-17,30.9-49.5,43.6-63.2,10-10.8,21.7-23.9,31.5-32.7,3.9,3.9,23.5,25.1,27.2,29.2-11.2,13.7-36.8,52.8-40,66.6l22.1-.1c2.4-7.6,24.5-44,30.7-50.1,8,8.2,24.7,37.4,30.6,50.2h21.5c-7.4-17.4-27.7-52.9-39-66.8,5.6-6.9,18.9-21.6,27.3-29.9,13.5,12.2,29.9,32.2,41.6,46.4s23.5,30.9,32.8,50.3H356c-7.1-26.9-51.2-79.4-80.8-109.7,4.4-4.4,13.4-11.6,21-14.5,12.4-4.8,19.3,3,25.2,8.2,24.9,22.7,62.8,57,84.5,93.6,4.4,7.5,8.3,15.1,12.5,22.6,3.3,0,12.1-.1,22.3-.2-5.6-19.5-28.6-51.1-41.9-66.9-20-22.1-39-44.2-62.2-63.2-5.1-4.2-9.1-8.7-15.5-11.9a39.4,39.4,0,0,0-35.7,0c-9.7,4.9-18.8,14.3-24.3,19.7l-20.6-18C233.7,11.4,226.2,5.2,218.9,0c-6.3,4.8-19.7,15.2-24.9,19.8-5.1,4.4-9.6,8.4-15.1,13.1ZM349.8,300.5a2.5,2.5,0,1,1-2.5,2.5A2.54,2.54,0,0,1,349.8,300.5Zm-238.6,0a2.5,2.5,0,1,1-2.5,2.5A2.48,2.48,0,0,1,111.2,300.5Zm162.8,5h2.9c0-.8-.1-12.5-.2-17v-3.2h-2.8c.1,3.8.1,16.4.1,20.2Zm-266.6,0h3.1c1.3-5.4,2.5-10.9,3.8-16.3,1.5,5.4,2.9,10.8,4.5,16.3h2.8l5.7-20.2H24.5l-4.3,17.3c-.9-3.7-3.7-14.2-4.5-17.3H13c-.6,2.3-3.5,14.9-4.1,17.2L4.2,285.3H1.7c.8,3.2,5.2,18.1,5.7,20.2Zm36.8,0h3.1c1.3-5.4,2.5-10.9,3.8-16.3,1.5,5.4,2.9,10.8,4.5,16.3h2.8l5.7-20.2H61.3L57,302.6c-.9-3.7-3.7-14.2-4.5-17.3H49.8c-.6,2.3-3.5,14.9-4.1,17.2L41,285.3H38.5c.7,3.2,5.2,18.1,5.7,20.2Zm110.5-21.2c-13.2-.3-13.3,21.2-.4,21.2C167,305.5,167.5,284.6,154.7,284.3Zm.2,2.2c-9.6-.3-9.4,16.8-.7,16.9C163.2,303.5,163.7,286.7,154.9,286.5Zm143.8-2.2c-13.2-.3-13.3,21.2-.4,21.2,12.7,0,13.2-21,.4-21.2Zm.2,2.1c-9.6-.3-9.4,16.8-.7,16.9,8.9.1,9.5-16.6.7-16.9ZM124.7,305.5h11.6c-.1-1.3-.1-1.9-.1-2.7-1.4,0-7.1-.1-8.7-.1l-.1-14.2v-3.2h-2.8C124.7,289.1,124.7,301.7,124.7,305.5Zm48.2-20.2v2.1c.6,0,5.2.1,6,.1,0,4.1.1,15.8.1,18h2.8c0-2.1.1-13.2.1-18,3.5,0,4.5,0,5.6-.1v-2.2h-7c-2.7.1-5.1.1-7.6.1ZM377.1,303a8.41,8.41,0,0,1-3.8,1,8.06,8.06,0,0,1-8.6-8.3c.1-4.1,2-6.2,3.5-7.2a8.19,8.19,0,0,1,5.3-1.4,29.94,29.94,0,0,1,3.6.6v-2.4a22.53,22.53,0,0,0-4.9-.6c-6.9,0-10.2,5.8-10.1,11.1a10.34,10.34,0,0,0,11.3,10.4,18.93,18.93,0,0,0,3.8-.6c-.1-.8-.1-2.2-.1-2.6Zm-151-.1a22.27,22.27,0,0,0-.3,2.6c.3.1,2.8.8,3.1.9,4,.8,8.8-.2,9.1-5.4.5-7.3-10.9-6.2-9.1-11.6,1.1-3.4,5.9-2.2,8-1.6.1-.3.4-1.5.5-2a16.65,16.65,0,0,0-5-.8c-7.6.3-8.1,7.6-3.6,10.5,2.4,1.5,7.5,2.1,6.2,6.4-2.2,3.8-7.7,1.5-8.9,1Zm-12.2-17.6h-2.6v11.4c0,4-.7,7.6-4.9,7.6-3.7,0-5-2.9-4.9-6.4V285.4h-2.6v14.1c0,4.4,2.9,7.3,7.5,7.2s7.1-2.7,7.5-7.2c.1-2.3.1-5.8.1-8-.1-1.8-.1-4.4-.1-6.2Zm106.4,20.2V289.4l9.6,16.1h3.3c0-6.7,0-13.5.1-20.2h-2.5v7.6c0,3,.1,5.6,0,8.5l-10-16.1H318l-.1,20.2Zm-69.9,0h2.4l.1-7.2c6,.3,10.3-.9,10.4-6.6-.1-5.3-4.3-6.4-9.1-6.4h-3.7c-.1,1.6-.1,18.1-.1,20.2Zm2.5-9.5c4.6.1,7.9-.2,7.8-4.3s-3.4-4.4-7.8-4.3Zm168.6-6.8,5.3,14.7c.6,2,2.8,2.1,3.5.1,1.9-5.4,3.4-10.4,5.2-15.8.3,3.7.8,14.5.9,17.3h2.4c-.1-1.7-.9-17.8-1-20.2l-3.7-.1c-1.6,4.4-4.6,13.7-5.6,16.7l-5.7-16.7h-3.5c-.2,2.2-1.1,19.6-1.2,20.3h2.6c.1-2.8.7-13.3.8-16.3ZM80.7,305.5h3.1c1.3-5.4,2.5-10.9,3.8-16.3,1.5,5.4,2.9,10.8,4.5,16.3h2.8l5.7-20.2H97.8l-4.3,17.3c-.9-3.7-3.7-14.2-4.5-17.3H86.3c-.6,2.3-3.5,14.9-4.1,17.2l-4.7-17.2H75c.8,3.2,5.2,18.1,5.7,20.2Zm318.2-21.1c-13.2-.3-13.3,21.2-.4,21.2C411.2,305.7,411.7,284.7,398.9,284.4Zm.1,2.2c-9.6-.3-9.4,16.8-.7,16.9C407.3,303.6,407.9,286.9,399,286.6ZM0,263.9H67.4v-17l-50.5-.1V179.7L.1,179.5C0,179.5,0,263.9,0,263.9Zm168.4-67.4H202l.1,67.3,16.9.1V196.6h33.6v-17H168.3l.1,16.9Zm184.2,49.2V179.4h-17v67.3H285.2V179.3l-16.9.1c-.1,15.6,0,31,0,46.5s-3,31.1,9.9,36.5c5.9,2.4,36.5,1.3,45.3,1.3,12.8.2,29.1,2,29.1-18ZM431.2,230v16.7l-60.1.1v17c15.7-.2,31.4,0,47.1,0,12,0,29.6,2.8,30-17.5.2-12.3,2.8-31.1-14.3-33.3-6.7-.9-36.6.2-47.4-.2V196.5l56-.1v-17H396.3c-12.5,0-26.6-1.1-26.6,19.7,0,11.2-2.7,29.3,15.2,30.6,14.8,1.2,31.4-.8,46.3.3ZM112.4,178.2c-22.3,3-40.4,22.9-37.5,49a43.47,43.47,0,0,0,49,37.9c22.2-2.7,40.7-23.5,37.4-49.5a43.44,43.44,0,0,0-48.9-37.4Zm1.3,17.1c-13.4,2.5-24.7,14.6-21.8,31.3,3.9,22.1,33.5,30.4,47.7,10.9C154.1,217.8,136.9,191,113.7,195.3Zm68.7,259.6c3.7-2.3,27.1-17.8,36.4-23.9,5.5,3.8,27.7,19.2,34.8,23.9l19.9-12.7a393.37,393.37,0,0,0,47-35.1c16.2-13.9,25-23.3,38-36.5,11.6-13.5,23.3-27.1,32.7-42.3-16.3-.1-22.9-.1-25.8-.1-1.2,1.5-2.6,3.5-5.4,7.1-14.9,18.9-37.2,42.7-56.1,57.2-18,13.8-31,24.6-50.4,36.9-3-1.8-5.3-3.6-8.4-5.7-2.6-1.7-6.4-4.1-8.3-6.1,1.4-1.8,3.5-3.1,5.7-4.9,5.7-4.7,15.1-12.4,19.9-17.3l8.6-7.8c17.8-18.6,23.1-24.1,40-46,2.1-2.7,7.8-10.4,9-13.5H294.4c-4.7,5.5-10,13.1-14.8,18.3l-11.2,12.3c-3.5,3-14,14.6-18.9,18.9l-20.4,18c-3.4,2.8-6.6,6.3-10.2,8.6-3.7-1.7-16.8-13.4-20.8-16.7-1.8-1.5-2.7-2.7-4.4-4.3-13.1-12.1-20-20.2-31.2-33.5-5.3-7-10.9-14.1-15.9-21.3l-23.9-.2c3.4,9.7,27.9,39.1,35.5,48.3l42.4,41.1c-1.4,1.7-15.6,10.1-18.3,11.8-8.9-6.2-23-16-34.5-24.6a281.49,281.49,0,0,1-37.2-33.4c-12.9-13.9-24.1-28.3-35.8-43.3H51.5c1.1,2.9,4.4,7.5,6.2,10.2,5.3,8,14.3,20.5,20.4,27.8a469.65,469.65,0,0,0,39,40.9c15.5,12.8,29,23,45.8,34.7,4,2.8,14.1,9.7,19.5,13.2ZM194.2,47.7c9.2,9.6,16.5,17.7,24.7,26.2,5.3-5.9,20.6-22,24.8-26.2-5.3-5-20.7-19-24.8-22.6-2.6,2.2-20.8,19.1-24.7,22.6Z"
          fill="#fff"
          fillRule="evenodd"
        />
      </g>
    </svg>
  ),
  arrowLongIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 12h14M13 5l7 7-7 7"></path>
    </svg>
  ),
  arrowIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
    dataOpen = false,
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      data-open={dataOpen}
    >
      <path d="m9 6 6 6-6 6"></path>
    </svg>
  ),
  compareIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 3v18M5 8l-3 3 3 3M19 8l3 3-3 3M2 11h7M15 11h7"></path>
    </svg>
  ),
  LanguageIcon: ({
    width = '18px',
    height = '18px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    // <svg
    //   id="Layer_1"
    //   data-name="Layer 1"
    //   xmlns="http://www.w3.org/2000/svg"
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   className={className}
    //   viewBox="0 0 50.68 50.68"
    // >
    //   <g id="Layer_1-2" data-name="Layer_1">
    //     <path
    //       d="M33.14,21.58a2.9,2.9,0,0,1,.83,1L43.1,40.81c.07.07.07.14.13.34a1.15,1.15,0,0,1-1.79,1.11c-.14-.07-.21-.21-.28-.28-.69-1.45-1.59-3-2.42-4.42-.35-.7-.76-1.32-1.18-2H27.4c-1.11,2.08-2.56,4.43-3.53,6.5a1.15,1.15,0,0,1-1,.42,1,1,0,0,1-1-1,.63.63,0,0,1,.07-.35l9.27-18.53c.21-.35.48-.83.83-1a1.1,1.1,0,0,1,1,.07Zm-5,11.76h8.57l-4.28-8.58ZM9,12.87l19.44.07a1.15,1.15,0,0,1,1.1.69,1.17,1.17,0,0,1,0,1,1.15,1.15,0,0,1-1,.76H26c-1.18,1.17-2.15,2.21-3.12,3.25-1.45,1.52-2.83,2.9-4.56,4.77l6.15,6.15a1.1,1.1,0,0,1,.28,1.32,1.36,1.36,0,0,1-.69.69,1.2,1.2,0,0,1-1.25-.28L16.61,25l-5.33,5.6a1.33,1.33,0,0,1-1.31.42,1.17,1.17,0,0,1-.69-.7,1.23,1.23,0,0,1,.35-1.31c1.86-1.8,3.59-3.73,5.39-5.67l-2.28-2.21a1.21,1.21,0,0,1-.28-1.32,1.26,1.26,0,0,1,.69-.62,1.15,1.15,0,0,1,1.25.42l2.21,2,6.15-6.36-13.9.07a1.13,1.13,0,0,1-1.17-.69A1.18,1.18,0,0,1,8.86,13Zm4.57-3.53h5.94a.91.91,0,0,1,.9.62,1,1,0,0,1,0,.9.9.9,0,0,1-.9.62h-6a1,1,0,0,1-1-.62,1.66,1.66,0,0,1,0-.83.93.93,0,0,1,1-.62Z"
    //       fill={fill}
    //     />
    //   </g>
    // </svg>
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="9"></circle>
      <path d="M3 12h18M12 3c2.5 2.5 2.5 15.5 0 18M12 3c-2.5 2.5-2.5 15.5 0 18"></path>
    </svg>
  ),
  GlobeIcon: ({
    width = '18px',
    height = '18px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
    >
      {/* <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M33.14,21.58a2.9,2.9,0,0,1,.83,1L43.1,40.81c.07.07.07.14.13.34a1.15,1.15,0,0,1-1.79,1.11c-.14-.07-.21-.21-.28-.28-.69-1.45-1.59-3-2.42-4.42-.35-.7-.76-1.32-1.18-2H27.4c-1.11,2.08-2.56,4.43-3.53,6.5a1.15,1.15,0,0,1-1,.42,1,1,0,0,1-1-1,.63.63,0,0,1,.07-.35l9.27-18.53c.21-.35.48-.83.83-1a1.1,1.1,0,0,1,1,.07Zm-5,11.76h8.57l-4.28-8.58ZM9,12.87l19.44.07a1.15,1.15,0,0,1,1.1.69,1.17,1.17,0,0,1,0,1,1.15,1.15,0,0,1-1,.76H26c-1.18,1.17-2.15,2.21-3.12,3.25-1.45,1.52-2.83,2.9-4.56,4.77l6.15,6.15a1.1,1.1,0,0,1,.28,1.32,1.36,1.36,0,0,1-.69.69,1.2,1.2,0,0,1-1.25-.28L16.61,25l-5.33,5.6a1.33,1.33,0,0,1-1.31.42,1.17,1.17,0,0,1-.69-.7,1.23,1.23,0,0,1,.35-1.31c1.86-1.8,3.59-3.73,5.39-5.67l-2.28-2.21a1.21,1.21,0,0,1-.28-1.32,1.26,1.26,0,0,1,.69-.62,1.15,1.15,0,0,1,1.25.42l2.21,2,6.15-6.36-13.9.07a1.13,1.13,0,0,1-1.17-.69A1.18,1.18,0,0,1,8.86,13Zm4.57-3.53h5.94a.91.91,0,0,1,.9.62,1,1,0,0,1,0,.9.9.9,0,0,1-.9.62h-6a1,1,0,0,1-1-.62,1.66,1.66,0,0,1,0-.83.93.93,0,0,1,1-.62Z"
          fill={fill}
        />
      </g> */}
      <circle cx={12} cy={12} r={8} fill="none" stroke={fill} strokeWidth={1.6} />
      <path
        d="M4 12h16M12 4c2.5 2.2 2.5 13.8 0 16M12 4c-2.5 2.2-2.5 13.8 0 16"
        fill="none"
        stroke={fill}
        strokeWidth={1.6}
      />
    </svg>
  ),
  basketIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      fill="none"
      stroke={fill}
      className={className}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 4h2l2.2 11.2a1 1 0 0 0 1 .8h8.6a1 1 0 0 0 1-.8L20 7H6"></path>
      <circle cx="9" cy="20" r="1.3"></circle>
      <circle cx="17" cy="20" r="1.3"></circle>
    </svg>
  ),
  visual1: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M13 3 5 13h6l-1 8 8-10h-6z"></path>
    </svg>
  ),
  visual2: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z"></path>
    </svg>
  ),
  starIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="m12 3 2.6 5.4 5.9.8-4.3 4.1 1 5.8L12 16.9 6.8 19l1-5.8L3.5 9.2l5.9-.8z"
        fill={fill}
      ></path>
    </svg>
  ),
  homeIcon: ({
    width = '24px',
    height = '24px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 11 12 4l8 7M6 10v9h12v-9"></path>
    </svg>
  ),
  robotIcon: ({
    width = '24px',
    height = '24px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="5" y="8" width="14" height="11" rx="3"></rect>
      <path d="M12 4v4M8.5 13h.01M15.5 13h.01M9 19v2M15 19v2M3 12v3M21 12v3"></path>
    </svg>
  ),
  retailIcon: ({
    width = '24px',
    height = '24px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="6" y="3" width="12" height="18" rx="2"></rect>
      <path d="M9 6h2M9 9h2M9 12h2M14 6v6M14 16h-5v2h5z"></path>
    </svg>
  ),
  wearableIcon: ({
    width = '24px',
    height = '24px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="7" y="7" width="10" height="10" rx="3"></rect>
      <path d="M9 7l1-4h4l1 4M9 17l1 4h4l1-4"></path>
    </svg>
  ),
  audioIcon: ({
    width = '24px',
    height = '24px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 12h2l2-6 3 14 3-18 3 14 2-4h3"></path>
    </svg>
  ),
  visionIcon: ({
    width = '24px',
    height = '24px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"></path>
      <circle cx="12" cy="12" r="2.6"></circle>
    </svg>
  ),
  edgecomputingIcon: ({
    width = '24px',
    height = '24px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="7" y="7" width="10" height="10" rx="1.5"></rect>
      <path d="M10 3v4M14 3v4M10 17v4M14 17v4M3 10h4M3 14h4M17 10h4M17 14h4"></path>
    </svg>
  ),
  kioskIcon: ({
    width = '24px',
    height = '24px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="6" y="3" width="12" height="13" rx="1.5"></rect>
      <path d="M12 16v3M8 21h8"></path>
    </svg>
  ),
  AiChat: ({
    width = '24px',
    height = '24px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        fill="none"
        stroke={fill}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13 3 5 13h6l-1 8 8-10h-6z"
      ></path>
    </svg>
  ),
  BasketIcon: ({
    width = '20px',
    height = '20px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 4h2l2.2 11.2a1 1 0 0 0 1 .8h8.6a1 1 0 0 0 1-.8L20 7H6"></path>
      <circle cx="9" cy="20" r="1.3"></circle>
      <circle cx="17" cy="20" r="1.3"></circle>
    </svg>
  ),
  userIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="8" r="4"></circle>
      <path d="M4 21c0-4 3.6-7 8-7s8 3 8 7"></path>
    </svg>
  ),
  usersIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      // stroke={fill}
      // strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx={9} cy={8} r={3.2} fill="none" stroke={fill} strokeWidth={1.6} />
      <path
        d="M3.5 19c0-3.2 2.6-5.4 5.5-5.4s5.5 2.2 5.5 5.4"
        fill="none"
        stroke={fill}
        strokeWidth={1.6}
        strokeLinecap="round"
      />
      <path
        d="M16 5.2a3 3 0 0 1 0 5.8M17.5 19c0-2.6-1-4.4-2.6-5.4 2.7-.2 5.1 1.9 5.1 5.4"
        fill="none"
        stroke={fill}
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  menuIcon: ({
    width = '20px',
    height = '20px',
    fill = '#fff',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 6h18M3 12h18M3 18h18"></path>
    </svg>
  ),
  boxIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 8 12 3 3 8v8l9 5 9-5z"></path>
      <path d="M3 8l9 5 9-5M12 13v8"></path>
    </svg>
  ),
  favIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 20s-7-4.5-7-9.5A4 4 0 0 1 12 7a4 4 0 0 1 7 3.5C19 15.5 12 20 12 20z"></path>
    </svg>
  ),
  shieldIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="M12 3l7 3v6c0 4.5-3 7.7-7 9-4-1.3-7-4.5-7-9V6z"
        fill="none"
        stroke={fill}
        strokeWidth={1.7}
        strokeLinejoin="round"
      />
      <path
        d="M9 12l2 2 4-4"
        fill="none"
        stroke={fill}
        strokeWidth={1.7}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  googleIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 12.2c0-.7-.06-1.4-.18-2H12v3.8h5.1a4.4 4.4 0 0 1-1.9 2.9v2.4h3.1c1.8-1.7 2.7-4.1 2.7-7.1z"></path>
      <path d="M12 21c2.4 0 4.5-.8 6-2.2l-3.1-2.4c-.8.6-2 .9-2.9.9-2.3 0-4.2-1.5-4.9-3.6H3.9v2.5A9 9 0 0 0 12 21z"></path>
      <path d="M7.1 13.7a5.4 5.4 0 0 1 0-3.4V7.8H3.9a9 9 0 0 0 0 8.4z"></path>
      <path d="M12 6.6c1.3 0 2.5.5 3.4 1.3l2.6-2.6A9 9 0 0 0 3.9 7.8l3.2 2.5C7.8 8.1 9.7 6.6 12 6.6z"></path>
    </svg>
  ),
  appleIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M16 13c0 3 2 4 2 4s-1.4 3-3.3 3c-1 0-1.6-.6-2.7-.6s-1.8.6-2.7.6C7.3 20 5 16.6 5 13.4 5 10.2 7 9 8.8 9c1 0 1.9.7 2.7.7S13 9 14.3 9c.7 0 2.2.2 3.1 1.5-1.4.9-1.4 2.5-1.4 2.5z"></path>
      <path d="M14 6c.6-.8.9-1.8.8-2.8-.9.1-1.9.6-2.5 1.4-.5.6-1 1.6-.8 2.6 1 .1 1.9-.5 2.5-1.2z"></path>
    </svg>
  ),
  EyeOn: ({ width = '24px', height = '24px', fill = 'var(--icon-color)', onClick = null }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M44.91,27.33a20,20,0,0,1-8,8.77A21.74,21.74,0,0,1,26.64,39,23.54,23.54,0,0,1,16,36.74a22.31,22.31,0,0,1-9.76-8.9,3.74,3.74,0,0,1-.69-2.35,4.63,4.63,0,0,1,.86-2.4,23.88,23.88,0,0,1,8.17-8.35,21.47,21.47,0,0,1,10.83-3.08,21.11,21.11,0,0,1,11,2.91,24,24,0,0,1,8.34,8.48l.09.17a7.38,7.38,0,0,1,.47,2,4.45,4.45,0,0,1-.34,2l-.05,0ZM25.74,18.6A6.76,6.76,0,1,1,19,25.36,6.77,6.77,0,0,1,25.74,18.6ZM35.93,34.39a18.13,18.13,0,0,0,7.14-7.88,3.09,3.09,0,0,0,.22-1.2A6.89,6.89,0,0,0,43,24a22,22,0,0,0-7.62-7.71,18.94,18.94,0,0,0-9.93-2.65,19.13,19.13,0,0,0-9.8,2.83,21.76,21.76,0,0,0-7.49,7.66l0,.08a2.58,2.58,0,0,0-.51,1.37A1.9,1.9,0,0,0,8,26.77l0,.09a20.4,20.4,0,0,0,8.86,8.08A21.38,21.38,0,0,0,26.6,37,19.32,19.32,0,0,0,35.93,34.39Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  EyeOff: ({ width = '24px', height = '24px', fill = 'var(--icon-color)', onClick = null }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M44.81,27.8a20,20,0,0,1-8,8.76,21.77,21.77,0,0,1-10.34,2.89,23.25,23.25,0,0,1-10.6-2.26c-.16,0-.26-.15-.42-.21l1.68-1.41a21.11,21.11,0,0,0,9.29,1.83,19.34,19.34,0,0,0,9.34-2.62,18.06,18.06,0,0,0,7.14-7.87,3.63,3.63,0,0,0,.21-1.21,4.24,4.24,0,0,0-.32-1.31,23.33,23.33,0,0,0-5-5.93l1.58-1.31a26.16,26.16,0,0,1,5.25,6.29l.1.16a6.86,6.86,0,0,1,.47,2,4.1,4.1,0,0,1-.36,2.05l-.06.05Zm-3.1-14.38C37.62,16.83,14,36.35,10,39.71c-1.83,1.47-3.36-.52-1.68-2l3.52-2.94a22.22,22.22,0,0,1-5.67-6.4A3.71,3.71,0,0,1,5.5,26a4.58,4.58,0,0,1,.84-2.41,23.9,23.9,0,0,1,8.19-8.34,21.52,21.52,0,0,1,10.81-3.1,21,21,0,0,1,10.54,2.68l4.2-3.47C41.55,10.17,43.55,11.85,41.71,13.42Zm-28.29,20,6-5a6.48,6.48,0,0,1-.53-2.63A6.79,6.79,0,0,1,25.65,19a6.65,6.65,0,0,1,3.78,1.16l4.83-4a19.82,19.82,0,0,0-8.87-2.1,19.48,19.48,0,0,0-9.82,2.84,21.46,21.46,0,0,0-7.5,7.66l-.05,0A2.43,2.43,0,0,0,7.49,26a2.08,2.08,0,0,0,.37,1.21l0,.05a20.49,20.49,0,0,0,5.51,6.09ZM32,23.39a7.39,7.39,0,0,1,.42,2.41,6.79,6.79,0,0,1-6.77,6.77,6.58,6.58,0,0,1-3.52-1l9.82-8.14Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  emailIcon: ({
    width = '18px',
    height = '18px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="5" width="18" height="14" rx="2"></rect>
      <path d="m4 7 8 6 8-6"></path>
    </svg>
  ),
  notifIcon: ({
    width = '15px',
    height = '15px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    // <svg
    //   viewBox="0 0 24 24"
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   className={className}
    //   fill="none"
    //   stroke={fill}
    //   strokeWidth="1.7"
    //   strokeLinecap="round"
    //   strokeLinejoin="round"
    // >
    //   <path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6M10 19a2 2 0 0 0 4 0"></path>
    // </svg>
    <svg onClick={onClick} width={width} height={height} className={className} viewBox="0 0 24 24">
      <path
        d="M12 3l1.7 5.1L19 10l-5.3 1.9L12 17l-1.7-5.1L5 10l5.3-1.9z"
        fill="none"
        stroke={fill}
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
    </svg>
  ),
  coinIcon: ({
    width = '15px',
    height = '15px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg onClick={onClick} width={width} height={height} className={className} viewBox="0 0 24 24">
      <circle cx={12} cy={12} r={8} fill="none" stroke={fill} strokeWidth={1.7} />
      <circle cx={12} cy={12} r={3.2} fill="none" stroke={fill} strokeWidth={1.7} />
    </svg>
  ),
  passwordIcon: ({
    width = '18px',
    height = '18px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="5" y="11" width="14" height="9" rx="2"></rect>
      <path d="M8 11V8a4 4 0 0 1 8 0v3"></path>
    </svg>
  ),
  overviewIcon: ({
    width = '18px',
    height = '18px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 3v5M12 16v5M3 12h5M16 12h5M6 6l3 3M15 15l3 3M18 6l-3 3M9 15l-3 3"></path>
    </svg>
  ),
  locationIcon: ({
    width = '18px',
    height = '18px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 21c4-4 7-7.4 7-11a7 7 0 0 0-14 0c0 3.6 3 7 7 11z"></path>
      <circle cx="12" cy="10" r="2.6"></circle>
    </svg>
  ),
  chartIcon: ({
    width = '18px',
    height = '18px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 4v16h16" fill="none" stroke={fill} strokeWidth={1.7} strokeLinecap="round" />
      <path
        d="M8 16v-4M12 16V8M16 16v-6"
        fill="none"
        stroke={fill}
        strokeWidth={1.7}
        strokeLinecap="round"
      />
    </svg>
  ),
  settingIcon: ({
    width = '18px',
    height = '18px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="3.2"></circle>
      <path d="M19.4 13.5a7.8 7.8 0 0 0 0-3l1.7-1.3-1.8-3.1-2 .8a7.6 7.6 0 0 0-2.6-1.5L14.4 3h-3.6l-.3 2.4a7.6 7.6 0 0 0-2.6 1.5l-2-.8L4 9.2l1.7 1.3a7.8 7.8 0 0 0 0 3L4 14.8l1.8 3.1 2-.8c.8.7 1.7 1.2 2.6 1.5l.3 2.4h3.6l.3-2.4c.9-.3 1.8-.8 2.6-1.5l2 .8 1.8-3.1z"></path>
    </svg>
  ),
  logoutIcon: ({
    width = '18px',
    height = '18px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3M10 17l-5-5 5-5M5 12h11"></path>
    </svg>
  ),
  rewardIcon: ({
    width = '18px',
    height = '18px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="9" width="18" height="4" rx="1"></rect>
      <path d="M5 13v7h14v-7M12 9v11M12 9S9 9 8 7.5 9 4 12 9zM12 9s3 0 4-1.5S15 4 12 9z"></path>
    </svg>
  ),
  clockIcon: ({
    width = '18px',
    height = '18px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="9"></circle>
      <path d="M12 7v5l3 2"></path>
    </svg>
  ),
  DeviceIcon: ({
    width = '18px',
    height = '18px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* <rect x="3" y="3" width="7" height="7" rx="1.5"></rect>
      <rect x="14" y="3" width="7" height="7" rx="1.5"></rect>
      <rect x="3" y="14" width="7" height="7" rx="1.5"></rect>
      <rect x="14" y="14" width="7" height="7" rx="1.5"></rect> */}
      <rect x={4} y={4} width={16} height={11} rx={2} fill="none" stroke={fill} strokeWidth={1.6} />
      <path d="M9 20h6M12 15v5" fill="none" stroke={fill} strokeWidth={1.6} strokeLinecap="round" />
    </svg>
  ),
  VerifyIcon: ({
    width = '18px',
    height = '18px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m9 12 2 2 4-4"></path>
      <path d="M12 2.5 14.5 5l3.5-.3.3 3.5 2.2 2.8-2.2 2.8-.3 3.5-3.5-.3L12 21.5 9.5 19l-3.5.3-.3-3.5L3.5 13l2.2-2.8L6 6.7l3.5.3z"></path>
    </svg>
  ),
  truckIcon: ({
    width = '18px',
    height = '18px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z"></path>
      <circle cx="7" cy="18" r="1.6"></circle>
      <circle cx="17" cy="18" r="1.6"></circle>
    </svg>
  ),
  returnIcon: ({
    width = '18px',
    height = '18px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 12a9 9 0 0 1 15-6.7L21 8M21 3v5h-5M21 12a9 9 0 0 1-15 6.7L3 16M3 21v-5h5"></path>
    </svg>
  ),
  fullFillIcon: ({
    width = '18px',
    height = '18px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 8l9-5 9 5v8l-9 5-9-5z"></path>
      <path d="m8.5 11.5 2.5 2.5 4.5-4.5"></path>
    </svg>
  ),
  filterIcon: ({
    width = '18px',
    height = '18px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 5h18M6 12h12M10 19h4"></path>
    </svg>
  ),
  LikeIcon: ({
    width = '18px',
    height = '18px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M7 11v9H4a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1zM7 11l4-7a2 2 0 0 1 2 2v3h5.5a1.5 1.5 0 0 1 1.5 1.8l-1.3 7A1.5 1.5 0 0 1 17 20H7z"></path>
    </svg>
  ),
  cameraIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 8h3l1.5-2.2h7L17 8h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"></path>
      <circle cx="12" cy="13" r="3.4"></circle>
    </svg>
  ),
  shopIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill={fill}
    >
      {/* <path d="M4 9V7l2-3h12l2 3v2M5 9h14v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zM4 9a2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0"></path> */}

      <path d="M841-518v318q0 33-23.5 56.5T761-120H201q-33 0-56.5-23.5T121-200v-318q-23-21-35.5-54t-.5-72l42-136q8-26 28.5-43t47.5-17h556q27 0 47 16.5t29 43.5l42 136q12 39-.5 71T841-518Zm-272-42q27 0 41-18.5t11-41.5l-22-140h-78v148q0 21 14 36.5t34 15.5Zm-180 0q23 0 37.5-15.5T441-612v-148h-78l-22 140q-4 24 10.5 42t37.5 18Zm-178 0q18 0 31.5-13t16.5-33l22-154h-78l-40 134q-6 20 6.5 43t41.5 23Zm540 0q29 0 42-23t6-43l-42-134h-76l22 154q3 20 16.5 33t31.5 13ZM201-200h560v-282q-5 2-6.5 2H751q-27 0-47.5-9T663-518q-18 18-41 28t-49 10q-27 0-50.5-10T481-518q-17 18-39.5 28T393-480q-29 0-52.5-10T299-518q-21 21-41.5 29.5T211-480h-4.5q-2.5 0-5.5-2v282Zm560 0H201h560Z" />
    </svg>
  ),
  paymentCardIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="5" width="18" height="14" rx="2.5"></rect>
      <path d="M3 10h18M7 15h3"></path>
    </svg>
  ),
  LockIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="5" y="11" width="14" height="9" rx="2"></rect>
      <path d="M8 11V8a4 4 0 0 1 8 0v3"></path>
    </svg>
  ),
  ArrowIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M17.18,24.74c6.05-6.12,8.37-8.54,14.42-14.58,1.9-1.71,3,.83,1.85,1.83L20,25.57c4.41,4.36,9,8.86,13.31,13.22,1.92,1.76-.12,3.75-1.83,2.14L17.12,26.72a1.31,1.31,0,0,1,0-2Z"
          fill={fill}
          fillRule="evenodd"
        />
      </g>
    </svg>
  ),
  MenuIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      version="1.1"
      viewBox="0 0 568.86 419.81"
      fill={fill}
    >
      <g id="Layer_x0020_1">
        <metadata id="CorelCorpID_0Corel-Layer" />
        <path
          className="fil0"
          d="M45.08 0.01c160.28,0 320.6,0 480.88,0 58.83,0.36 55.53,79.27 0,79.89 -160.28,0 -320.6,0 -480.88,0 -60.61,-0.36 -59.59,-80.58 0,-79.89z"
        />
        <path
          className="fil0"
          d="M45.08 167.5c160.28,0 320.6,0 480.88,0 58.83,0.36 55.53,79.27 0,79.89 -160.28,0 -320.6,0 -480.88,0 -60.61,-0.36 -59.59,-80.58 0,-79.89z"
        />
        <path
          className="fil0"
          d="M45.08 339.92c160.28,0 320.6,0 480.88,0 58.83,0.36 55.53,79.27 0,79.89 -160.28,0 -320.6,0 -480.88,0 -60.61,-0.36 -59.59,-80.58 0,-79.89z"
        />
      </g>
    </svg>
  ),
  keyIcon: ({
    width = '16px',
    height = '16px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
    >
      <circle cx={8} cy={12} r={3.6} fill="none" stroke={fill} strokeWidth={1.7} />
      <path
        d="M11.6 12H20M17 12v3M20 12v2.4"
        fill="none"
        stroke={fill}
        strokeWidth={1.7}
        strokeLinecap="round"
      />
    </svg>
  ),
  carIcon: ({
    width = '16px',
    height = '16px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
    >
      <path
        d="M4 13l1.6-4.6A2 2 0 0 1 7.5 7h9a2 2 0 0 1 1.9 1.4L20 13v5h-2.2v-2H6.2v2H4z"
        fill="none"
        stroke={fill}
        strokeWidth={1.7}
        strokeLinejoin="round"
      />
      <circle cx={8} cy={16} r={1.5} fill="none" stroke={fill} strokeWidth={1.7} />
      <circle cx={16} cy={16} r={1.5} fill="none" stroke={fill} strokeWidth={1.7} />
    </svg>
  ),
  BellIcon: ({
    width = '16px',
    height = '16px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
    >
      <path
        d="M6 16V11a6 6 0 1 1 12 0v5l2 2H4z"
        fill="none"
        stroke={fill}
        strokeWidth={1.7}
        strokeLinejoin="round"
      />
      <path d="M10 20a2 2 0 0 0 4 0" fill="none" stroke={fill} strokeWidth={1.7} />
    </svg>
  ),
  walletIcon: ({
    width = '16px',
    height = '16px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
    >
      <rect
        x={3}
        y={6}
        width={18}
        height={13}
        rx={2.5}
        fill="none"
        stroke={fill}
        strokeWidth={1.6}
      />
      <path d="M3 9h13a2 2 0 0 1 0 4H3" fill="none" stroke={fill} strokeWidth={1.6} />
      <circle cx={16.5} cy={11} r={1.1} fill={fill} />
    </svg>
  ),
  giftIcon: ({
    width = '16px',
    height = '16px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
    >
      <path
        d="M4 11h16v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"
        fill="none"
        stroke={fill}
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
      <path
        d="M3 8h18v3H3zM12 8v12"
        fill="none"
        stroke={fill}
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
    </svg>
  ),
  documentIcon: ({
    width = '16px',
    height = '16px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
    >
      <path
        d="M7 3h7l4 4v14H7z"
        fill="none"
        stroke={fill}
        strokeWidth={1.7}
        strokeLinejoin="round"
      />
      <path
        d="M14 3v4h4M9.5 13h5M9.5 16.5h5"
        fill="none"
        stroke={fill}
        strokeWidth={1.7}
        strokeLinecap="round"
      />
    </svg>
  ),
  downloadIcon: ({
    width = '16px',
    height = '16px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
    >
      <path
        d="M12 4v10m0 0l-4-4m4 4l4-4"
        fill="none"
        stroke={fill}
        strokeWidth={1.7}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5 18h14" fill="none" stroke={fill} strokeWidth={1.7} strokeLinecap="round" />
    </svg>
  ),
  lightIcon: ({
    width = '16px',
    height = '16px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
    >
      <path
        d="M9 18h6M10 21h4M12 3a6 6 0 0 0-4 10.5c.6.6 1 1.3 1 2.5h6c0-1.2.4-1.9 1-2.5A6 6 0 0 0 12 3z"
        fill="none"
        stroke={fill}
        strokeWidth={1.7}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  RefreshIcon: ({
    width = '16px',
    height = '16px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
    >
      <path
        d="M20 11a8 8 0 1 0-.9 4.5"
        fill="none"
        stroke={fill}
        strokeWidth={1.8}
        strokeLinecap="round"
      />
      <path
        d="M20 5v6h-6"
        fill="none"
        stroke={fill}
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  phoneIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--gray)',
    onClick = null,
    className = '',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
    >
      {/* <rect
        x={7}
        y={3}
        width={10}
        height={18}
        rx={2.5}
        fill="none"
        stroke={fill}
        strokeWidth={1.6}
      />
      <path d="M10.5 5.5h3" fill="none" stroke={fill} strokeWidth={1.6} strokeLinecap="round" /> */}
      <path
        d="M7 4h4l1.5 4-2 1.5a11 11 0 0 0 4 4l1.5-2 4 1.5v4a1.5 1.5 0 0 1-1.6 1.5C11 23 5 17 4.5 9.6A1.5 1.5 0 0 1 6 8z"
        stroke={fill}
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
    </svg>
  ),
  searchIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--gray)',
    onClick = null,
    className = '',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle cx={11} cy={11} r={6.5} fill="none" stroke={fill} strokeWidth={1.8} />
      <path d="M16 16l4 4" fill="none" stroke={fill} strokeWidth={1.8} strokeLinecap="round" />
    </svg>
  ),
  arrowDiagonalIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--gray)',
    onClick = null,
    className = '',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8 16L16 8M9 8h7v7"
        stroke={fill}
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  tagIcon: ({
    width = '16px',
    height = '16px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 13.5 13.5 20a2 2 0 0 1-2.8 0L3 12.3V3h9.3L20 10.7a2 2 0 0 1 0 2.8z"></path>
      <circle cx="7.5" cy="7.5" r="1.5"></circle>
    </svg>
  ),
  fireIcon: ({
    width = '16px',
    height = '16px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="M12 3c1 3-1 4-1 6 0-2-3-2-3 2a4 4 0 1 0 8 0c0-3-2-4-2-6-1 1-2 1-2-2z"
        fill="none"
        stroke={fill}
        strokeWidth="1.6"
        strokeLinejoin="round"
      ></path>
    </svg>
  ),
  send: ({
    width = '16px',
    height = '16px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="M21 3 3 10.5l7 2.5 2.5 7L21 3z"
        fill="none"
        stroke={fill}
        strokeWidth="1.7"
        strokeLinejoin="round"
      ></path>
      <path d="M21 3 10 13" fill="none" stroke={fill} strokeWidth="1.7"></path>
    </svg>
  ),
  telegramIcon: ({
    width = '16px',
    height = '16px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 192 192"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        stroke={fill}
        strokeWidth="12"
        d="M23.073 88.132s65.458-26.782 88.16-36.212c8.702-3.772 38.215-15.843 38.215-15.843s13.621-5.28 12.486 7.544c-.379 5.281-3.406 23.764-6.433 43.756-4.54 28.291-9.459 59.221-9.459 59.221s-.756 8.676-7.188 10.185c-6.433 1.509-17.027-5.281-18.919-6.79-1.513-1.132-28.377-18.106-38.214-26.404-2.649-2.263-5.676-6.79.378-12.071 13.621-12.447 29.891-27.913 39.728-37.72 4.54-4.527 9.081-15.089-9.837-2.264-26.864 18.483-53.35 35.835-53.35 35.835s-6.053 3.772-17.404.377c-11.351-3.395-24.594-7.921-24.594-7.921s-9.08-5.659 6.433-11.693Z"
      />
    </svg>
  ),
  whatsappIcon: ({
    width = '16px',
    height = '16px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 -0.5 25 25"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.5 19.0001C16.6157 18.9994 19.3559 16.9396 20.2224 13.9468C21.0889 10.954 19.873 7.74874 17.2396 6.0836C14.6062 4.41845 11.1892 4.69428 8.85695 6.76026C6.52471 8.82624 5.8387 12.185 7.174 15.0001L5.5 19.0001L9.892 18.0001C10.9809 18.6564 12.2286 19.0022 13.5 19.0001Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.541 11.0661C10.9717 11.0611 10.5137 10.5965 10.517 10.0271C10.5203 9.45781 10.9836 8.99849 11.5529 9.00013C12.1223 9.00177 12.5829 9.46375 12.583 10.0331C12.5802 10.606 12.1139 11.0683 11.541 11.0661V11.0661Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.417 13.918C14.4138 14.3397 14.6652 14.7217 15.0538 14.8854C15.4424 15.0491 15.8914 14.9622 16.1909 14.6653C16.4904 14.3684 16.5811 13.9202 16.4208 13.5302C16.2605 13.1402 15.8807 12.8854 15.459 12.885C14.8861 12.8828 14.4198 13.3451 14.417 13.918V13.918Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 10.0331C10.486 13.5001 13.8 15.3301 15.459 14.9511"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  CalendarIcon: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'currentColor',
  }) => (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4"
        y="5"
        width="16"
        height="15"
        rx="2.5"
        fill="none"
        stroke={fill}
        strokeWidth="1.6"
      ></rect>
      <path
        d="M4 9h16M8 3v4M16 3v4"
        fill="none"
        stroke={fill}
        strokeWidth="1.6"
        strokeLinecap="round"
      ></path>
    </svg>
  ),
  gaugeIcon: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'currentColor',
  }) => (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 18a8 8 0 1 1 16 0"
        fill="none"
        stroke={fill}
        strokeWidth="1.6"
        strokeLinecap="round"
      ></path>
      <path d="M12 18l4-5" fill="none" stroke={fill} strokeWidth="1.6" strokeLinecap="round"></path>
    </svg>
  ),
  hearthIcon: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'currentColor',
  }) => (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 20S4 14.5 4 9a4 4 0 0 1 8-1 4 4 0 0 1 8 1c0 5.5-8 11-8 11z"
        fill="none"
        stroke={fill}
        strokeWidth="1.7"
        strokeLinejoin="round"
      ></path>
    </svg>
  ),
  listIcon: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'currentColor',
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960"
      fill={fill}
      width={width}
      height={height}
      className={className}
      onClick={onClick}
    >
      <path d="M280-600v-80h560v80H280Zm0 160v-80h560v80H280Zm0 160v-80h560v80H280ZM160-600q-17 0-28.5-11.5T120-640q0-17 11.5-28.5T160-680q17 0 28.5 11.5T200-640q0 17-11.5 28.5T160-600Zm0 160q-17 0-28.5-11.5T120-480q0-17 11.5-28.5T160-520q17 0 28.5 11.5T200-480q0 17-11.5 28.5T160-440Zm0 160q-17 0-28.5-11.5T120-320q0-17 11.5-28.5T160-360q17 0 28.5 11.5T200-320q0 17-11.5 28.5T160-280Z" />
    </svg>
  ),
  gridIcon: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'currentColor',
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960"
      fill={fill}
      width={width}
      height={height}
      className={className}
      onClick={onClick}
    >
      <path d="M120-520v-320h320v320H120Zm0 400v-320h320v320H120Zm400-400v-320h320v320H520Zm0 400v-320h320v320H520ZM200-600h160v-160H200v160Zm400 0h160v-160H600v160Zm0 400h160v-160H600v160Zm-400 0h160v-160H200v160Zm400-400Zm0 240Zm-240 0Zm0-240Z" />
    </svg>
  ),
  shareIcon: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'currentColor',
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960"
      fill={fill}
      width={width}
      height={height}
      className={className}
      onClick={onClick}
    >
      <path d="M680-80q-50 0-85-35t-35-85q0-6 3-28L282-392q-16 15-37 23.5t-45 8.5q-50 0-85-35t-35-85q0-50 35-85t85-35q24 0 45 8.5t37 23.5l281-164q-2-7-2.5-13.5T560-760q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35q-24 0-45-8.5T598-672L317-508q2 7 2.5 13.5t.5 14.5q0 8-.5 14.5T317-452l281 164q16-15 37-23.5t45-8.5q50 0 85 35t35 85q0 50-35 85t-85 35Zm0-80q17 0 28.5-11.5T720-200q0-17-11.5-28.5T680-240q-17 0-28.5 11.5T640-200q0 17 11.5 28.5T680-160ZM200-440q17 0 28.5-11.5T240-480q0-17-11.5-28.5T200-520q-17 0-28.5 11.5T160-480q0 17 11.5 28.5T200-440Zm508.5-291.5Q720-743 720-760t-11.5-28.5Q697-800 680-800t-28.5 11.5Q640-777 640-760t11.5 28.5Q663-720 680-720t28.5-11.5ZM680-200ZM200-480Zm480-280Z" />
    </svg>
  ),
  returnIcon: ({
    width = '18px',
    height = '18px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 12a9 9 0 0 1 15-6.7L21 8M21 3v5h-5M21 12a9 9 0 0 1-15 6.7L3 16M3 21v-5h5"></path>
    </svg>
  ),
  ServiceIcon: ({
    width = '18px',
    height = '18px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960"
      onClick={onClick}
      width={width}
      height={height}
      className={className}

      fill={fill}
    >
      <path d="M686-132 444-376q-20 8-40.5 12t-43.5 4q-100 0-170-70t-70-170q0-36 10-68.5t28-61.5l146 146 72-72-146-146q29-18 61.5-28t68.5-10q100 0 170 70t70 170q0 23-4 43.5T584-516l244 242q12 12 12 29t-12 29l-84 84q-12 12-29 12t-29-12Zm29-85 27-27-256-256q18-20 26-46.5t8-53.5q0-60-38.5-104.5T386-758l74 74q12 12 12 28t-12 28L332-500q-12 12-28 12t-28-12l-74-74q9 57 53.5 95.5T360-440q26 0 52-8t47-25l256 256ZM472-488Z" />
    </svg>
  ),
  printIcon: ({
    width = '18px',
    height = '18px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960"
      onClick={onClick}
      width={width}
      height={height}
      className={className}

      fill={fill}
    >
      <path d="M640-640v-120H320v120h-80v-200h480v200h-80Zm-480 80h640-640Zm560 100q17 0 28.5-11.5T760-500q0-17-11.5-28.5T720-540q-17 0-28.5 11.5T680-500q0 17 11.5 28.5T720-460Zm-80 260v-160H320v160h320Zm80 80H240v-160H80v-240q0-51 35-85.5t85-34.5h560q51 0 85.5 34.5T880-520v240H720v160Zm80-240v-160q0-17-11.5-28.5T760-560H200q-17 0-28.5 11.5T160-520v160h80v-80h480v80h80Z" />
    </svg>
  ),
  carIconCategory: ({
    width = '18px',
    height = '18px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150">
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M111.14,89.79a9.89,9.89,0,0,1-9.26,6.62c-4.34,0-7.93-1.82-9.75-5.58l-8.06,0c-9.39,0-17.45,0-26.61-.11-1.52,3.85-5.23,5.8-9.33,5.84a10,10,0,0,1-9.24-5.78c-1.46-.13-2.79-.24-4.22-.39s-3-.32-4.5-.54a5,5,0,0,1-3.59-1.91c-.79-1.09-1.14-2.69-.9-5,1.79-16.73,13.7-18.06,23.68-19.18l.88-.1a10.42,10.42,0,0,0,4.86-2.84,44.08,44.08,0,0,1,10.28-6.61,34.46,34.46,0,0,1,9.45-2.67c12.08-1.78,21.18,1.83,31.23,5.83,3.59,1.43,7.15,2.8,10.83,4,3.92,1.29,5.68,1.48,6.54,5.78.5,4.16.87,6,1.13,7.28a18.83,18.83,0,0,1,.4,2.52c.81,10.3-4.11,12.28-9.8,12.73-1.13.09-2.34.11-3.55.14h-.47Zm-9.6-8.88A4.38,4.38,0,0,0,97.1,85.5a4.55,4.55,0,0,0,4.59,4.65c2.7,0,4.28-2.14,4.28-4.65a4.37,4.37,0,0,0-4.44-4.59Zm-53.38.16a4.42,4.42,0,0,0-4.49,4.59A4.21,4.21,0,0,0,48.14,90a4.16,4.16,0,0,0,4.41-4.36A4.33,4.33,0,0,0,48.16,81.07ZM61.55,63.45l15.72.11,2-6.54a30,30,0,0,0-10.44,2.1,24.82,24.82,0,0,0-7.31,4.33ZM99,63c.27-.61.53-1.25.78-1.93a62.77,62.77,0,0,0-8-2.55,31.91,31.91,0,0,0-6.17-1.06c-.54,1.68-1.25,4-1.83,5.79l-.14.47,14.47,1.07c.28-.55.57-1.15.86-1.78Zm18.81,5.14c-1.75-.66-5.72-2.12-8.88-3.26l-3.65-1.32c-.5,1.19-1,2.24-1.52,3.23-.66,1.26-1.38,2.45-2.25,3.84a1.06,1.06,0,0,1-1.06.52c-4.1-.42-10.26-.9-17.16-1.28-5.66-.3-11.8-.55-17.63-.62-5.61-.07-11,0-15.49.33a41.44,41.44,0,0,0-8.95,1.35,14.54,14.54,0,0,0-5.86,3.34,13.69,13.69,0,0,0-3.6,7.84c-.1.62-.09,1.48.68,1.59,1,.16,2.38.19,3.46.28l2.08.18c.66-5.4,4.41-8.84,10-8.87A10.08,10.08,0,0,1,58.29,84.4l15.15.09,17.58.1a10.08,10.08,0,0,1,9.9-9.54c5.59,0,9.71,3,10.7,8.28,5.45.68,7.13-.93,7.44-3a14.16,14.16,0,0,0-.39-4.63,48.92,48.92,0,0,1-.89-7.6Z"
          onClick={onClick}
          width={width}
          height={height}
          className={className}

          fill={fill}
          fill-rule="evenodd"
        />
      </g>
    </svg>
  ),
  usersIconCategory: ({
    width = '18px',
    height = '18px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150">
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M60.6,60.94a9.86,9.86,0,0,1-9.48,9.65c-6.35-.19-10-4.92-9.87-9.88.1-5.14,3.61-9.45,9.16-9.58A9.8,9.8,0,0,1,60.6,60.94ZM106.51,55A11.06,11.06,0,0,1,95.88,65.84c-7.11-.22-11.16-5.51-11-11.08.1-5.76,4-10.6,10.26-10.74A11,11,0,0,1,106.51,55Zm-37.16,55a6.09,6.09,0,0,0,1.92.29h49a8.1,8.1,0,0,0,1.45-.12c1.84,0,4.48-1,4.5-4.93.12-15.73-6.4-29.21-19.34-35.62,4-3.73,7.44-7.3,7.19-14.92-.34-10.32-9.52-17.2-18.86-17.21A17.81,17.81,0,0,0,77.31,54.71c-.11,5.2,2.64,11.87,8.08,14.82-8.25,3.83-19.85,12.74-19.55,35.7a4.78,4.78,0,0,0,3.52,4.82ZM118,102.32l-44.52.2C74.19,84.08,86,74,96,73.88c12.36-.09,21.17,13,22,28.44ZM27.46,110a5.38,5.38,0,0,0,1.71.26H62.82a8.41,8.41,0,0,1-1.3-3.71c-.05-.42-.06-1.93-.06-3.4l-30.31.12c.62-16.44,11.18-25.48,20.06-25.53a14.77,14.77,0,0,1,9.88,3.54c3.2,2.62,7.61-2.15,3.68-5A23.66,23.66,0,0,0,60.9,74c3.61-3.31,6.63-6.51,6.42-13.31-.3-9.2-8.5-15.35-16.81-15.35A15.89,15.89,0,0,0,34.56,60.69c-.1,4.65,2.35,10.59,7.2,13.23-7.36,3.41-17.71,11.36-17.43,31.84a4.24,4.24,0,0,0,3.13,4.29Z"
          onClick={onClick}
          width={width}
          height={height}
          className={className}

          fill={fill}
          fill-rule="evenodd"
        />
      </g>
    </svg>
  ),
  carFinesIcon: ({
    width = '18px',
    height = '18px',
    fill = 'currentColor',
    onClick = null,
    className = '',
  }) => (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150">
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M84,94.39h-2c-9.53,0-15.08,0-24.94-.12a10.19,10.19,0,0,1-3.42,4.37,10.71,10.71,0,0,1-6.26,2,10.26,10.26,0,0,1-6.18-1.92A9.59,9.59,0,0,1,38,94.31c-1.42-.12-2.72-.24-4.13-.39s-3-.33-4.58-.54a5.22,5.22,0,0,1-3.74-2c-.82-1.14-1.19-2.78-.93-5.2,1.83-17.12,14-18.48,24.19-19.62l.89-.1a10.42,10.42,0,0,0,4.86-2.86c.68-.59,1.39-1.2,2.26-1.83A48.4,48.4,0,0,1,65,56.85a5.44,5.44,0,0,1,.5-.22L65.65,48a13.8,13.8,0,0,1,2.19-7.59,12.13,12.13,0,0,1,6-4.75h0a14.88,14.88,0,0,1,2.86-.64,29.11,29.11,0,0,1,3.59-.28q8.07-.18,16.1-.23c5.36,0,10.72,0,16.11,0a20.26,20.26,0,0,1,2.85.22,14.34,14.34,0,0,1,2.56.55h0c3.49,1.27,5.52,4.85,6.66,9.09A51.23,51.23,0,0,1,125.93,57c0,11.81-.1,23.3-.22,34.88q-.1,9.51-.17,19.14v1.17l-1.41-.92c-3.65-2.4-5.71-3.76-9.56-6.09-.89-.54-1.18-.21-1.91.23l-4.39,2.7-1,.6c-2,1.18-2.8,1.62-4.82.1-.39-.29-1.15-.85-2-1.46-1.4-1-2.71-2-3.19-2.3h0c-.73-.53-1-.39-1.76,0l-.2.1L84,111.28V94.38Zm24-9.17h4.5a3.39,3.39,0,0,1,3.52,3.13,3.28,3.28,0,0,1-3.52,3.17c-1.53,0-3.28.09-4.78,0-1.72-.1-3.43-1.18-3.42-3.18s1.44-3.11,3.71-3.11ZM84,87.77v-15c-6-.14-12.54-.23-18.67-.3-5.21-.08-10.54,0-15.74.33a40.9,40.9,0,0,0-9.07,1.38,14.37,14.37,0,0,0-5.89,3.37A13.67,13.67,0,0,0,31,85.4a1.72,1.72,0,0,0,0,.26c0,.52,0,1.11.61,1.21h.11c1,.07,2.25.17,3.4.27l2,.17a10.71,10.71,0,0,1,3-6.14,10.5,10.5,0,0,1,7.45-2.9,10.7,10.7,0,0,1,7.57,3A10.46,10.46,0,0,1,58,87.59l14.43.09c4.3,0,8.52.07,11.55.08Zm23.6-10.91h5.13a3.22,3.22,0,0,1,2.33,1,3.29,3.29,0,0,1-2.33,5.61h-5.13a3.28,3.28,0,0,1-2.32-5.61A3.3,3.3,0,0,1,107.61,76.86ZM97.55,67h15.19a3.26,3.26,0,0,1,2.33,1,3.3,3.3,0,0,1,1,2.32,3.26,3.26,0,0,1-1,2.33,3.3,3.3,0,0,1-2.33,1H97.55a3.86,3.86,0,0,1-2.49-1,3,3,0,0,1,0-4.63A3.81,3.81,0,0,1,97.55,67ZM72,52.93H84V52.7c0-1.73.06-3.36,0-4.89a8,8,0,0,0-1.79-5,5.66,5.66,0,0,0-4.21-2H78a5.68,5.68,0,0,0-4.19,1.86A7,7,0,0,0,72,47.43v3.08c0,.75,0,1.5,0,2.41Zm18.82,47.32c3.09-1.41,4.68-2.18,5.9-2.79l.68-.33.45.28c.69.42,7.06,4.58,7.31,4.59S110,99.34,110,99.31l4-2.21.31.18c2,1.15,2.75,1.63,4.2,2.52l.55.33c.1-9.87.17-19.85.24-29.81l.06-7.47V61.39A112.66,112.66,0,0,0,119,48.53a13,13,0,0,0-.8-3.35,11.74,11.74,0,0,0-1.54-2.65A3.53,3.53,0,0,0,115,41.25a8.89,8.89,0,0,0-2.83-.32l-10.26,0L89,40.93a18.58,18.58,0,0,1,1.12,3.75,31.29,31.29,0,0,1,.54,6c0,4.4,0,10.37.07,15,0,1.61,0,3.06,0,4.22.06,7.37,0,14.79,0,22.1,0,2.78,0,5.53,0,8.25ZM47.52,84.42a4.34,4.34,0,0,0-3.13,1.28A4.66,4.66,0,0,0,43.15,89a4.54,4.54,0,0,0,1.25,3.26,4.44,4.44,0,0,0,3.19,1.29,4.23,4.23,0,0,0,3.1-1.26,5.06,5.06,0,0,0,0-6.6,4.33,4.33,0,0,0-3.13-1.28ZM61.61,66.28l22,.09,0-6.27a34.07,34.07,0,0,0-13.28,1.65A27.41,27.41,0,0,0,61.61,66.28Z"
          onClick={onClick}
          width={width}
          height={height}
          className={className}

          fill={fill}
          fill-rule="evenodd"
        />
      </g>
    </svg>
  ),
};

export default MainIcons;
